import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { AppContext } from 'store/AppContext';
import { getSveitarfelog } from 'common/services/apiService';


const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function SveitarfelagFilter(props) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const {
    setFilters,
    setSveitarfelagsnumerFromFilter,
    kjordaemisnumer,
    kjorstadir,
    disabled
  } = props;
  const [sveitarfelogList, setSveitarfelogList] = useState([]);
  const [sveitarfelogFiltered, setSveitarfelogFiltered] = useState([]);
  const [sveitarfelagsnumer, setSveitarfelagsnumer] = useState('');

  useEffect(() => {
    async function fetchSveitarfelog() {
      const { data, isSuccess, error } = await getSveitarfelog(context, []);
      
      if (isSuccess) {
        setSveitarfelogList(data);
      } else {
        console.error(error);
      }
    };

    fetchSveitarfelog();
  }, [context]);

  // Reset when kjördæmi changes
  useEffect(() => {
    setSveitarfelagsnumer('');
    setFilters(state => ({
      ...state,
      sveitarfelagsnumer: ''
    }));
  }, [kjordaemisnumer, setFilters]);

  // Filter sveitarfelog by kjördæmi
  useEffect(() => {
    let arr = [];
    kjorstadir.forEach(k => {
      sveitarfelogList.forEach(s => {
        if (s.sveitarfelagsnumer === k.sveitarfelagsnumer && k.numerKjordaemis === kjordaemisnumer) {
          if (!arr.includes(s)) arr.push(s);
        }
      })
    });
    setSveitarfelogFiltered(arr);
  }, [kjordaemisnumer, kjorstadir, sveitarfelogList]);

  const handleChange = event => {
    setSveitarfelagsnumer(event.target.value);
    setSveitarfelagsnumerFromFilter && setSveitarfelagsnumerFromFilter(event.target.value);

    setFilters((state) => ({
      ...state,
      sveitarfelagsnumer: event.target.value,
    }));
  };

  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel id="filters-sveitarfelag-select" shrink>
          Sveitarfélag
        </InputLabel>
        <Select
          labelId="filters-sveitarfelag-select-label"
          id="filters-sveitarfelag-select"
          value={sveitarfelagsnumer ? sveitarfelagsnumer : ''}
          displayEmpty={true}
          onChange={handleChange}
          disabled={disabled ? disabled : false}
        >
          <MenuItem value="">
            <em>Öll sveitarfélög</em>
          </MenuItem>
          {sveitarfelogFiltered
            .map((s) => (
            <MenuItem key={s.sveitarfelagsnumer} value={s.sveitarfelagsnumer}>
              {s.nafn}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}